<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminOrder/">Orders</a>
      </li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a
        routerLink="/admin/orders/">Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/orders/">Order</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">New Order</li>
    </ol>
  </nav>
  <div class="invalid-feedback d-block shift-invalid-login" id="senderNameError" [hidden]="!senderNameError">
    {{senderNameError}}
  </div>
  <div class="invalid-feedback d-block shift-invalid-login" id="receiverNameError" [hidden]="!receiverNameError">
    {{receiverNameError}}
  </div>
  <div class="row">
    <div class="col">
      <div class="row align-items-center">
        <div class="col-md-6"></div>
        <div class="col-md-6 mt-4 mt-md-0 text-right float-right">
          <button class="btn btn-orange text-white p-2 ml-2 shift-receiving" *ngIf="step === 4"
                  (click)="submitCreateStock()">
            <b>Submit</b></button>
        </div>
      </div>
    </div>
  </div>
  <form [hidden]="step !== 1" style="padding-bottom: 8em;">
    <div class="row mt-2">
      <div class="col">
        <div class="inner-box pt-4 pb-4">
          <div class="row">
            <div class="col-3">
              <div class="form-group mb-md-0">
                <label class="control-label" required>Sender</label>
                <ng-select id="contactName" [(ngModel)]="senderName" (change)="getSenderAddress()" (blur)="typeSender()"
                           required
                           [ngModelOptions]="{standalone: true}"
                           [items]="contactSender"
                           bindLabel="contactName"
                           [ngClass]="{'is-invalid':senderNameError}"
                           [searchFn]="customSearchFn" placeholder="Search for Sender"
                           [searchWhileComposing]="true">
                  <ng-template ng-option-tmp let-item="item">
                    {{item?.contactName}} <br/>
                    <small>{{item?.companyName}}</small>
                  </ng-template>
                  <ng-template ng-header-tmp>
                    <div>
                      <button class="btn btn-outline-primary btn-sm" (click)="addSender()">
                        <svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor"
                             xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd"
                                d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
                          <path fill-rule="evenodd"
                                d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
                        </svg>
                        Add
                      </button>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <label [hidden]="!senderNameAddressText">Address :<span
                class="ml-1">{{senderNameAddressText}}</span></label>
            </div>
            <div class="col-3">
              <div class="form-group mb-md-0">
                <label class="control-label" required>Receiver</label>
                <ng-select id="contarctName" [(ngModel)]="receiverName" (change)="getReceiverAddress()"
                           (blur)="typeReceiver()" required
                           [ngModelOptions]="{standalone: true}"
                           [items]="contactReceiver"
                           bindLabel="contactName" placeholder="Search for Receiver"
                           [searchFn]="customSearchFn"
                           [ngClass]="{'is-invalid':receiverNameError}"
                           [searchWhileComposing]="true">
                  <ng-template ng-option-tmp let-item="item">
                    {{item?.contactName}} <br/>
                    <small>{{item?.companyName}}</small>
                  </ng-template>
                  <ng-template ng-header-tmp>
                    <div>
                      <button class="btn btn-outline-primary btn-sm" (click)="addReceiver()">
                        <svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor"
                             xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd"
                                d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
                          <path fill-rule="evenodd"
                                d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
                        </svg>
                        Add
                      </button>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <label [hidden]="!receiverNameAddressText">Address :<span class="ml-1">{{receiverNameAddressText}}</span></label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12 mb-1 text-danger fw-500"
           *ngIf="statusText9 || statusText10 || statusText11 || statusText14 ">Please Enter Mandatory Fields
      </div>
      <div class="col">
        <ul class="list-inline tab-list">
          <li class="list-inline-item" style="margin-right:-0.2rem!important;">
            <a class="list-inline-item" (click)=" tabChange('addProducts');"
               [ngClass]="{'active': tabClicked === 'addProducts'}">
              Add Products
              <span class="dot bg-danger"
                    *ngIf="statusText19 || statusText20 || senderNameError || receiverNameError">
              </span>
            </a>
          </li>
          <li class="list-inline-item" style="margin-right: -0.2rem!important;">
            <a class="nav-link additionalInfo" (click)=" tabChange('packageType');"
               [ngClass]="{'active': tabClicked === 'packageType'}">
              Package Type
              <span class="dot bg-danger"
                    *ngIf="statusText21 || statusText22 || statusText23 || statusText24 || statusText25 || statusText26 || statusText27 || statusText28">
              </span>
            </a>
          </li>
          <li class="list-inline-item" style="margin-right: -0.2rem!important;">
            <a class="nav-link additionalInfo" (click)=" tabChange('payments');"
               [ngClass]="{'active': tabClicked === 'payments'}">
              Payment
            </a>
          </li>
          <li class="list-inline-item" style="margin-right: -0.2rem!important;">
            <a class="nav-link additionalInfo" (click)=" tabChange('shipping');"
               [ngClass]="{'active': tabClicked === 'shipping'}">
              Shipping
            </a>
          </li>
        </ul>
        <div class="inner-box inner-box-mobile" style="min-height:325px;">
          <div class="" *ngIf="tabClicked == 'addProducts'">
            <div class="row">
              <div class="col-8 mb-2">
                <input type="text" id="textValue" [(ngModel)]="textVal" class="form-control" placeholder="enter storeSKU with comma separated" [ngModelOptions]="{standalone: true}" required>
              </div>
              <div class="col-4">
                <button type="submit" (click)="textValues()" style="margin-bottom: 5px;" class="btn btn-orange" id="">Submit</button>
              </div>
            </div>
            <div class="col-md table-3">
              <table class="table packing-table packing-table-2">
                <thead class="thead-light">
                <tr>
                  <th style="width: 500px">Product Name</th>
                  <th style="text-transform:uppercase;width: 200px;">SKU</th>
                  <th style="width: 200px">Quantity</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>

                <tr *ngFor="let r of stockLines">
                  <td style="width: 500px">{{r.productName }}</td>
                  <td style="text-transform:uppercase;width: 200px;" (cbOnSuccess)="copied($event)" ngxClipboard
                      [cbContent]="r.sku">{{r.sku }}
                  </td>
                  <td style="width: 200px"><input type="text" [(ngModel)]="r.actualQuantity"
                                                  class="form-control width-120"
                                                  onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                  [ngClass]="{'is-invalid':statusText18}" (blur)="typeQuantity()"
                                                  [ngModelOptions]="{standalone: true}" required></td>
                  <td style="width: 200px">
                    <a (click)="removeProduct(r)" id="action" data-toggle="modal" data-target="#deleteEntryModal"
                       style="white-space: nowrap;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                        <defs>
                          <style>.a {
                            fill: #848484;
                          }
                          </style>
                        </defs>
                        <path class="a" id="action"
                              d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                              transform="translate(-7.5 -4.5)"/>
                      </svg>
                      <span class="ml-2 mt-2" id="delete">Delete</span>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td style="width: 500px">
                    <ng-select id="product" [(ngModel)]="activeProduct" style="width: 500px;height: 38px;"
                               [ngModelOptions]="{standalone: true}" required (open)="open()"
                               [ngClass]="{'service-error':statusText20}" (blur)="selectProduct()"
                               [ngClass]="{'is-invalid':statusText20}"
                               [items]="selectedProducts"
                               bindLabel="productName"
                               placeholder="Search for Product"
                               [searchFn]="productSearch"
                               [searchWhileComposing]="true" (change)="addNewLine()">
                      <ng-template ng-option-tmp let-item="item">
                        {{item?.productName}} <br/>
                        <small>{{item?.sku}}</small>
                      </ng-template>
                      <ng-template ng-header-tmp>
                        <div>
                          <button class="btn btn-outline-primary btn-sm" (click)="addNewProduct()">
                            <svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16"
                                 fill="currentColor"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd"
                                    d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
                              <path fill-rule="evenodd"
                                    d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
                            </svg>
                            Add a new Product
                          </button>
                        </div>
                      </ng-template>
                    </ng-select>
                  </td>
                  <td style="width :200px"></td>
                  <td style="width :200px"><input type="text" id="selecetedQuantity" [(ngModel)]="actualQuantity"
                                                  onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                  class="form-control width-120" [ngModelOptions]="{standalone: true}"
                                                  (change)="addNewLine()" (keydown.enter)="addNewLine()"
                                                  required>
                  </td>
                  <td></td>
                </tr>
                </tbody>
              </table>
              <hr class="wd">
            </div>
          </div>
          <div class="" *ngIf="tabClicked == 'packageType'">
            <h2 class="color-3 text-capitalize mt-2 mb-3">How is your inventory configured?</h2>
            <div class="row">
              <div class="col-md-12 dip-in">
                <div class="form-radio mr-5">
                  <input type="radio" name="skuConfig" id="SingleSKU" [(ngModel)]="productConfig" (change)="change()"
                         [ngModelOptions]="{standalone: true}" required value="SKU">
                  <label for="SingleSKU">One SKU per box
                    <p class="label-para-size">Each box contains a single SKU</p>
                  </label>
                </div>
                <br>
                <div class="form-radio">
                  <input type="radio" name="skuConfig" id="multipleSKU" [(ngModel)]="productConfig" (change)="change()"
                         [ngModelOptions]="{standalone: true}" required value="MULTI_SKU">
                  <label for="multipleSKU">Multiple SKUs per box
                    <p class="label-para-size">Each box has 2 or more SKUs</p>
                  </label>
                </div>
              </div>
            </div>
            <div>
              <div *ngIf="productConfig === 'SKU'">
                <h2 class="color-3 text-capitalize mt-5 mb-3">Packing Configuration</h2>

                <div class="table-3" style="overflow-x:auto">
                  <table class="table packing-table packing-table-2" style="line-height:1.5">
                    <thead class="thead-light">
                    <tr>
                      <th>Product / SKU</th>
                      <th>Quantity</th>
                      <th>No.of Boxes</th>
                      <th>Quantity/Box</th>
                      <th style="width: 200px">Package Type<br>Box Dimensions (in cms)</th>
                      <th>Wt/Box (Kg)</th>
                      <th>Total Wt (Kg)</th>
                      <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let r of stockLines">
                      <tr *ngIf="!showAddShipRow(r)">
                        <td [attr.rowspan]="(!r.shipLines?.length ? 1 : r.shipLines.length)"
                            style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 300px;">
                          {{r.productName}} <br>
                          {{r.sku}}
                        </td>
                        <td [attr.rowspan]="(!r.shipLines?.length ? 1 : r.shipLines.length)">
                          {{r.actualQuantity}} <img src="/./assets/images/tick.svg" class="float-right"
                                                    title="Shipment quantity is mathced"
                                                    style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"
                                                    *ngIf="showShipIcon(r)"> <img src="/./assets/images/close.svg"
                                                                                  class="float-right"
                                                                                  title="Shipment quantity is not mathced"
                                                                                  style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"
                                                                                  *ngIf="!showShipIcon(r) && (r.qtyPerBoxTmp || r.numOfBoxesTmp || r.shipLines.length>1)">
                        </td>
                        <td class="bg-color2"><input type="text" [disabled]="showAddShipRow(r)"
                                                     (change)="totalWeightCal()"
                                                     [(ngModel)]="r.numOfBoxesTmp"
                                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                     class="form-control width-120"
                                                     [ngModelOptions]="{standalone: true}"
                                                     required></td>
                        <td class="bg-color2"><input type="text" [disabled]="showAddShipRow(r)"
                                                     [(ngModel)]="r.qtyPerBoxTmp"
                                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                     class="form-control width-120"
                                                     [ngModelOptions]="{standalone: true}"
                                                     required></td>
                        <td class="bg-color2" style="width: 200px;padding-top: 12px!important;">
                          <ng-select id="package" class="mt-1" [(ngModel)]="r.packageType"
                                     [disabled]="showAddShipRow(r)"
                                     appendTo="body" (open)="openPackage()" (change)="populateDimensions(r)"
                                     [ngModelOptions]="{standalone: true}" required
                                     [items]="package"
                                     bindLabel="packingType"
                                     bindValue="packingType"
                                     placeholder="Package Type">
                          </ng-select>
                          <div class="mt-2 ml-1">
                            <input type="text" style="width: 50px !important" [disabled]="r.packageType !== 'Custom'"
                                   [(ngModel)]="r.boxLength"
                                   [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline w-48"
                                   placeholder="L"/>

                            <input type="text" style="width: 50px !important" [disabled]="r.packageType !== 'Custom'"
                                   [(ngModel)]="r.boxWidth"
                                   [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline w-48"
                                   placeholder="W"/>

                            <input type="text" style="width: 50px !important" [disabled]="r.packageType !== 'Custom'"
                                   [(ngModel)]="r.boxHeight"
                                   [ngModelOptions]="{standalone: true}" class="form-control ml-1 d-inline w-48"
                                   placeholder="H"/>
                          </div>
                        </td>
                        <td class="bg-color2"><input type="text" [disabled]="showAddShipRow(r)"
                                                     [(ngModel)]="r.boxWeight" (change)="totalWeightCal()"
                                                     appOnlyNumbers class="form-control  width-120"
                                                     [ngModelOptions]="{standalone: true}" required/>
                        <td>
                          <input disabled [(ngModel)]="r.totalWeight" [ngModelOptions]="{standalone: true}"
                                 class="form-control  width-120" required/>
                        </td>
                        <td class="bg-color2">
                          <a (click)="addShipmentLine(r)" *ngIf="showAddShipmentBtn(r) ">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21.34 21.34">
                              <defs>
                                <style>.ab {
                                  fill: #ee7125;
                                }



                                </style>
                              </defs>
                              <path class="ab"
                                    d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z"
                                    transform="translate(-3.375 -3.375)"/>
                            </svg>
                          </a>
                        </td>
                      </tr>
                      <ng-container *ngFor="let s of r.shipLines; let j=index;">
                        <tr *ngIf="r?.shipLines?.length && j!==0">
                          <td class="" *ngIf="showAddShipRow(r) && j==1"
                              [attr.rowspan]="(!r.shipLines?.length ? 1 : r.shipLines.length-1)">{{r.productName}}
                          </td>
                          <td class="" *ngIf="showAddShipRow(r) && j==1"
                              [attr.rowspan]="(!r.shipLines?.length ? 1 : r.shipLines.length-1)">{{r.actualQuantity}}
                            <img
                              src="/./assets/images/tick.svg" class="float-right" title="Shipment quantity is mathced"
                              style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="showAddShipRow(r)">
                            <img
                              src="/./assets/images/close.svg" class="float-right"
                              title="Shipment quantity is not mathced"
                              style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="!showAddShipRow(r)">
                          </td>
                          <td><input type="text" disabled [(ngModel)]="s.numberOfBoxes"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                     class="form-control width-120" [ngModelOptions]="{standalone: true}" required></td>
                          <td><input type="text" disabled [(ngModel)]="s.quantityPerBox"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                     class="form-control width-120" [ngModelOptions]="{standalone: true}" required></td>
                          <td style="width:200px !important;padding-top: 12px!important;">
                            <input type="text" disabled [(ngModel)]="s.packageType"
                                   onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                   class="form-control w-100" [ngModelOptions]="{standalone: true}" required>
                            <div class="mt-1 ml-1">
                              <input type="text" disabled [(ngModel)]="s.boxLength"
                                     [ngModelOptions]="{standalone: true}"
                                     class="form-control ml-1 d-inline " style="width:50px !important" placeholder="L"/>

                              <input type="text" disabled [(ngModel)]="s.boxWidth" [ngModelOptions]="{standalone: true}"
                                     class="form-control ml-1 d-inline " style="width:50px !important" placeholder="W"/>

                              <input type="text" disabled [(ngModel)]="s.boxHeight"
                                     [ngModelOptions]="{standalone: true}"
                                     class="form-control ml-1 d-inline " style="width:50px !important" placeholder="H"/>
                            </div>
                          </td>
                          <td><input type="text" disabled [(ngModel)]="s.boxWeight" appOnlyNumbers
                                     class="form-control width-120" [ngModelOptions]="{standalone: true}" required></td>
                          <td><input type="text" disabled [(ngModel)]="s.totalWeight"
                                     class="form-control width-120" [ngModelOptions]="{standalone: true}" required></td>
                          <td><a (click)="removeShipmentLine(r, s)">
                            <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                              <defs>
                                <style>.a {
                                  fill: #848484;
                                }



                                </style>
                              </defs>
                              <path class="a"
                                    d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                                    transform="translate(-7.5 -4.5)"/>
                            </svg>
                          </a></td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    </tbody>
                    <tfoot>
                    <tr>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div *ngIf="productConfig === 'MULTI_SKU'">

                <h2 class="color-3 text-capitalize mt-5 mb-2">Packing Configuration</h2>
                <div class="row">
                  <div class="col-md-3">

                    <div class="form-group required">
                      <select class="form-control" id="numberOfBoxes" [(ngModel)]="numberOfBoxesM"
                              [ngModelOptions]="{standalone: true}" (change)="changeBox()"
                              [ngModelOptions]="{standalone: true}" required>
                        <option value="1" selected>1</option>
                        <option value="2" selected>2</option>
                        <option value="3" selected>3</option>
                        <option value="4" selected>4</option>
                        <option value="5" selected>5</option>
                      </select>

                    </div>
                  </div>
                </div>

                <div class="table-3 table-responsive">
                  <table class="table packing-table packing-table-2">
                    <thead class="thead-light">
                    <tr>
                      <th>Product / SKU</th>
                      <th style="text-align: center; white-space:nowrap ;">Shipment Qty</th>
                      <th *ngFor="let b of stockLines[0].shipLines;let i=index;">Box {{i + 1}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td colspan="2">Package type</td>
                      <td *ngFor="let b of stockLines[0].shipLines">
                        <ng-select id="packageMultiSku" class="mt-1" [(ngModel)]="b.packageType" appendTo="body"
                                   (open)="openPackage()"
                                   (change)="populateDimensions(b);selectPackType();"
                                   [ngModelOptions]="{standalone: true}" required
                                   [items]="package"
                                   bindLabel="packingType"
                                   bindValue="packingType"
                                   placeholder="Package Type" style="width: 220px;">
                        </ng-select>
                        <div class="mt-1 ml-1 ">
                          <input type="text" [disabled]="b.packageType !== 'Custom'" (change)="a(b)" appOnlyNumbers
                                 [(ngModel)]="b.boxLength" [ngModelOptions]="{standalone: true}"
                                 class="form-control d-inline w-48" placeholder="L (cms)" style="width: 60px;"/>
                          <input type="text" [disabled]="b.packageType !== 'Custom'" (change)="a(b)" appOnlyNumbers
                                 [(ngModel)]="b.boxWidth" [ngModelOptions]="{standalone: true}"
                                 class="form-control mx-1 d-inline w-48" placeholder="W (cms)" style="width: 60px;"/>
                          <input type="text" [disabled]="b.packageType !== 'Custom'" (change)="a(b)" appOnlyNumbers
                                 [(ngModel)]="b.boxHeight" [ngModelOptions]="{standalone: true}"
                                 class="form-control d-inline w-48" placeholder="H (cms)" style="width: 60px;"/>
                        </div>
                      </td>
                    </tr>
                    <tr *ngFor="let r of stockLines">
                      <td style="white-space: pre-wrap">
                        {{r.productName}} <br> {{r.sku}}
                      </td>
                      <td style="text-align: center;">{{r.actualQuantity}} <img src="/./assets/images/tick.svg"
                                                                                class="float-right"
                                                                                title="Shipment quantity is matched"
                                                                                style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"
                                                                                *ngIf="showIcon(r)"> <img
                        src="/./assets/images/close.svg"
                        class="float-right"
                        title="Shipment quantity is not matched"
                        style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;"
                        *ngIf="!showIcon(r) && fieldsEntered(r)">
                      </td>
                      <ng-container *ngFor="let b of r.shipLines">
                        <td *ngIf="b.productId == r.productId">
                          <input type="text" [(ngModel)]="b.quantityPerBox" [ngModelOptions]="{standalone: true}"
                                 onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                 class="form-control width-120">
                        </td>
                      </ng-container>
                    </tr>
                    <tr>
                      <td>Wt(kg)</td>
                      <td></td>
                      <td *ngFor="let b of stockLines[0].shipLines">
                        <input type="text" appOnlyNumbers
                               [(ngModel)]="b.boxWeight" [ngModelOptions]="{standalone: true}"
                               (change)="totalWeightCal()"
                               class="form-control d-inline ml-1 w-68" placeholder="Weight (kg)" style="width: 72px;"/>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="" *ngIf="tabClicked == 'shipping'">
            <h2 class="color-3 text-capitalize mt-2 mb-3">Select Your Carrier</h2>
            <div class="mt-2">
              <div class="table-3" style="overflow-x:auto;">
                <table class="table packing-table packing-table-2">
                  <thead class="thead-light">
                  <tr>
                    <th>Select</th>
                    <th></th>
                    <th>Courier Partner</th>
                    <th>Courier Mode</th>
                    <th>Price</th>
                    <th>Pickup Available</th>
                  </tr>
                  </thead>
                  <tbody *ngFor="let co of costEstimation; let i=index;">
                  <tr *ngFor="let c of co.costEstimates; let j=index;">
                    <td>
                      <div class="form-radio">
                        <input type="radio" id="co.costEstimates+{{i}}+{{j}}" (change)="selectCost(c)" required
                               name="costEstimate">
                        <label for="co.costEstimates+{{i}}+{{j}}"></label>
                      </div>
                    </td>
                    <td><img src="assets/images/1-{{co.carrierCode}}.png" style="height: 18px; width: 18px;"></td>
                    <td>
                      {{(co.carrierCode == 'SD' ? 'Shift' :
                      (co.carrierCode == 'DL' ? 'Delhivery' :
                      (co.carrierCode == 'GT' ? 'Gati' :
                      (co.carrierCode == 'DZ' ? 'Dotzot' :
                      (co.carrierCode == 'RD' ? 'Rapid Delivery' :
                      (co.carrierCode == 'SF' ? 'Shadow Fax' :
                      (co.carrierCode == 'BD' ? 'Blue Dart' :
                      (co.carrierCode == 'PR' ? 'Pickrr' :
                      (co.carrierCode == 'SY' ? 'Ship Yaari' :
                      (co.carrierCode == 'DE' ? 'Delhivery' :
                      (co.carrierCode == 'SG' ? 'Shippigo' :
                      (co.carrierCode == 'VS' ? 'Vamaship' :
                      (co.carrierCode == 'DN' ? 'Dunzo' :
                      (co.carrierCode == 'WF' ? 'Borzo' :
                      (co.carrierCode == 'XB' ? 'Xpressbees' :
                      (co.carrierCode == 'KE' ? 'Kerry' :
                      (co.carrierCode == 'KE' ? 'Kerry' :
                      (co.carrierCode == 'EG' ? 'EcomXpress EGS' :
                      (co.carrierCode == 'EX' ? 'EcomXpress Pro' : co.carrierCode)))))))))))))))))))}}

                      <div *ngIf="c.shippingPreference != ''"
                           style="display: inline-flex;">{{c.shippingPreference}}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="c?.deliveryMode && c?.serviceType">
                        {{c.deliveryMode + '/' + (c.serviceType || " ") | replaceStatus}}
                      </div>
                      <div *ngIf="c?.serviceType">{{c.serviceType | replaceStatus}}</div>
                      <div *ngIf="c?.deliveryMode">{{c.deliveryMode | replaceStatus}}</div>
                      <div>{{c.courier}}</div>
                    </td>
                    <td>{{c.totalAmount | currency:'INR'}}</td>
                    <td>{{"Yes"}}</td>
                  </tr>
                  </tbody>


                  <tfoot>
                  <tr *ngIf="costEstimation?.length ===0 || !costEstimation?.length">
                    <td [attr.colspan]="7" class="text-center">No Carriers available to serve the Order</td>
                  </tr>
                  </tfoot>
                </table>
                <div class="mt-2 m-3" *ngIf="others == true">
                  <div class="row">
                    <div class="col-md-4 requred">
                      <div class="form-group">
                        <label class="control-label">Carrier Name</label>
                        <input type="text" id="carrierName" class="form-control" [(ngModel)]="carrierName"
                               [ngModelOptions]="{standalone: true}"
                               (blur)="carrierNameBlur()" [ngClass]="{'is-invalid':carrierNameError}">
                        <div [hidden] = "!carrierNameError" class="invalid-feedback d-block shift-invalid-login" id="carrierNameError">
                          {{carrierNameError}}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 requred">
                      <div class="form-group">
                        <label class="control-label" for="shippedDate">Shipped Date</label>
                        <input type="date" id="shippedDate" class="form-control"packageType
                               [(ngModel)]="shippedDate" [ngModelOptions]="{standalone: true}"
                               (blur)="shippedDateBlur()" [ngClass]="{'is-invalid':shippedDateError}">

                        <div [hidden] = "!shippedDateError" class="invalid-feedback d-block shift-invalid-login" id="shippedDateError">
                          {{shippedDateError}}
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4 requred">
                      <div class="form-group">
                        <label class="control-label">Shipment Cost</label>
                        <input type="text" id="shipmentCost" class="form-control" [(ngModel)]="shipmentCostOther"
                               [ngModelOptions]="{standalone: true}"
                               (blur)="shipmentCostOtherBlur()" [ngClass]="{'is-invalid':shipmentCostOtherError}">
                        <div [hidden] = "!shipmentCostOtherError" class="invalid-feedback d-block shift-invalid-login" id="shipmentCostOtherError">
                          {{shipmentCostOtherError}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="control-label">AWB Number</label>
                        <input type="text" id="AWBNumber" class="form-control" [(ngModel)]="AWBNumber"
                               [ngModelOptions]="{standalone: true}">
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="control-label" for="deliveryPinCode">Tracking URL</label>
                        <input type="text" id="deliveryPinCode" class="form-control"
                               [(ngModel)]="trackingURL" [ngModelOptions]="{standalone: true}">
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="" *ngIf="tabClicked == 'payments'">
            <div class="row">
              <div class="col">
                <label><b>Please select Payment mode</b></label>
                <div class="row mt-2">
                  <div class="col-md-2 form-radio mr-4">
                    <input type="radio" name="codPaymentMode" id="codPaymentMode"
                           [(ngModel)]="paymentMode" [ngModelOptions]="{standalone: true}" required
                           value="COD">
                    <label for="codPaymentMode" class="mb-4">   COD</label>
                  </div>
                  <div class="col-md-2 form-radio">
                    <input type="radio" name="prepaidPaymentMode" id="prepaidPaymentMode"
                           [(ngModel)]="paymentMode" [ngModelOptions]="{standalone: true}" required
                           value="Prepaid">
                    <label for="prepaidPaymentMode">   Prepaid</label>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-3">
                    <label>Order Value</label>
                    <input type="text" [(ngModel)]="orderAmount" (blur)="orderAmountReq()"
                           [ngModelOptions]="{standalone: true}" appOnlyNumbers
                           class="form-control">
                  </div>
                  <span *ngIf="paymentMode == 'COD'"
                        ngbTooltip="Additional Charges for COD Rs40/- or 1.5% whichever is higher will be charged extra. Charges may differ for few carriers."><small>Additional Charges for COD Rs40/- or 1.5%...</small>
                    </span>
                  <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!orderAmountError">
                    {{orderAmountError}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <form [hidden]="step !== 4">
    <div class="row mt-2">
      <div class="col">
        <div class="invalid-feedback d-block shift-invalid-login" id="statusText30" [hidden]="!statusText30">
          {{statusText30}},to add balance click <a (click)="addCreditBalPopup()">here</a>
        </div>
        <div class="inner-box">
          <div class="row">
            <div class="col">
              <div class="text-center">
                <h2 class="text-black mb-3 review">Review and Confirm</h2>
              </div>
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-lg-6">
                      <h2 class="text-black mb-2 review">Sender Details</h2>
                      <label class="text-black">{{senderName?.contactName}}</label><br>
                      <label class="text-black">{{senderName?.mobile}}</label><br>
                      <label class="text-black">{{senderNameAddressText}}</label>
                    </div>
                    <div class="col-lg-6">
                      <h2 class="text-black mb-2 review">Receiver Details</h2>
                      <label class="text-black">{{receiverName?.contactName}}</label><br>
                      <label class="text-black">{{receiverName?.mobile}}</label><br>
                      <label class="text-black">{{receiverNameAddressText}}</label>
                    </div>
                  </div>
                  <hr class="row-bordered">
                  <h2 class="text-black mb-2 review">Shipping Details</h2>
                  <div class="row">
                    <div class="col-6">
                      <label class="text-black"><b>Product Config:</b>
                        <span *ngIf="productConfig == 'SKU'"
                        class="ml-1">{{'One SKU per box'}}</span>
                        <span *ngIf="productConfig == 'MULTI_SKU'"
                        class="ml-1">{{'Multiple SKUs per box'}}</span>
                      </label>
                    </div>
                    <div class="col-6">
                      <label class="text-black"><b>Shipping Carrier:</b><span class="ml-1">
                        {{(shippingCost.carrierCode == 'SD' ? 'Shift' :
                        (shippingCost.carrierCode == 'DE' ? 'Delhivery' :
                          (shippingCost.carrierCode == 'GT' ? 'Gati' :
                            (shippingCost.carrierCode == 'DZ' ? 'Dotzot' :
                              (shippingCost.carrierCode == 'RD' ? 'Rapid Delivery' :
                                (shippingCost.carrierCode == 'SF' ? 'Shadow Fax' :
                                  (shippingCost.carrierCode == 'VS' ? 'Vamaship' :
                                    (shippingCost.carrierCode == 'BD' ? 'Blue Dart' :
                                      (shippingCost.carrierCode == 'WF' ? 'Wefast' :
                                        (shippingCost.carrierCode == 'PR' ? 'Pickrr' :
                                          (shippingCost.carrierCode == 'DN' ? 'Dunzo' :
                                            (shippingCost.carrierCode == 'SY' ? 'Shipyaari' :
                                              (shippingCost.carrierCode == 'XB' ? 'Xpressbees' :
                                                (shippingCost.carrierCode == 'SG' ? 'Shippigo' :
                                                  (shippingCost.carrierCode == 'EG' ? 'EcomXpress EGS' :
                                                     (shippingCost.carrierCode == 'EX' ? 'EcomXpress Pro' :
                                                         (shippingCost.carrierCode == 'FE' ? 'FedEx' : shippingCost.carrierCode)))))))))))))))))}} </span>({{shippingCost.serviceType || shippingCost.deliveryMode }})</label>
                    </div>
                    <div class="col-6">
                      <label class="text-black"><b>Shipping Method:</b><span
                        class="ml-1">{{shipMethod  | replaceStatus}}</span></label>
                    </div>
                    <div class="col-6">
                      <label class="text-black"><b>Payment Mode:</b>
                        <span *ngIf="paymentMode == 'COD'"
                        class="ml-1">{{'Cash On Delivery'}}</span>
                        <span *ngIf="paymentMode == 'Prepaid'"
                        class="ml-1">{{'Prepaid'}}</span>
                      </label>
                    </div>
                    <div class="col-6">
                      <label *ngIf="orderAmount" class="text-black"><b>Order Value:</b><span
                        class="ml-1">{{orderAmount}}</span></label>
                    </div>
                    <div class="col-6">
                      <label class="text-black"><b>Weight of the Order :</b><span
                        class="ml-1">{{totalWeight}} {{'kg(s)'}}</span></label><br>
                    </div>
                  </div>
                  <hr class="row-bordered">
                  <div class="row">
                    <div class="col">
                      <h2 class="text-black mb-2 review">Product Details</h2>
                      <table class="table table-stripe">
                        <thead>
                        <tr>
                          <th>SKU</th>
                          <th>Product Name</th>
                          <th>Quantity</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let sl of stockLines">
                          <td class="text-black mb-3">{{sl.sku}}</td>
                          <td>{{sl.productName}}</td>
                          <td>{{sl.actualQuantity}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br><br>
  </form>
</section>

<div class="form-btn-section" [hidden]="step != 1">
  <div class="row">
    <div class="col-12 text-right" *ngIf="tabClicked == 'addProducts'">
      <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>
      <button type="submit" (click)="nextToPackageType()" class="btn btn-orange ml-2">Next</button>
    </div>
    <div class="col-12 text-right" *ngIf="tabClicked == 'packageType'">
      <button type="reset" (click)="back()" class="btn btn-cancel">Back</button>
      <button type="submit" (click)="nextToShipping()" class="btn btn-orange ml-2">Next</button>
    </div>
    <div class="col-12 text-right" *ngIf="tabClicked == 'payments'">
      <button type="reset" (click)="back()" class="btn btn-cancel">Back</button>
      <button type="submit" (click)="nextToPayments()" class="btn btn-orange ml-2">Next</button>
    </div>
    <div class="col-12 text-right" *ngIf="tabClicked == 'shipping'">
      <button type="reset" (click)="back()" class="btn btn-cancel">Back</button>
      <button type="submit" (click)="reviewAndConfirm()" class="btn btn-orange ml-2">Review Order</button>
    </div>
  </div>
</div>

<div class="form-btn-section" [hidden]="step != 4">
  <div class="row">
    <div class="col-12 text-left">
      <button type="button" (click)="selectShippingInformation()" class="btn btn-cancel">Back</button>
    </div>
  </div>
</div>


<div [ngStyle]="{'display': newSenderPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': newSenderPopup == 'Y'}" class="modal" id="customerDetails" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document" style="max-width:900px">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h2 class="modal-title">Sender Details
          <span class="dot bg-danger"
                *ngIf="statusText1 || statusText2 || statusText3 || statusText4 || statusText5 || statusText6 || statusText7">
              </span>
        </h2>
        <button type="button" class="close" (click)="cancelPopup()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4">
            <label class="control-label" for="companyName">Company Name</label>
            <div class="form-group ">
              <input type="text" id="companyName" [(ngModel)]="senderCompanyName" class="form-control"
                     (blur)="typeSenderName()"
                     [ngClass]="{'is-invalid':statusText1}" [ngModelOptions]="{standalone: true}"
                     onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                     autocomplete="off" required>
            </div>
          </div>
          <div class="col-md-4 required">
            <label class="control-label" for="senderName">Contact Name</label>
            <div class="form-group ">
              <input type="text" id="senderName" [(ngModel)]="senderContactName" class="form-control"
                     (blur)="typeSenderName()"
                     [ngClass]="{'is-invalid':statusText1}" [ngModelOptions]="{standalone: true}"
                     onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                     autocomplete="off" required>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText1" [hidden]="!statusText1">
                {{statusText1}}
              </div>
            </div>
          </div>
          <div class="col-md-4 required">
            <label class="control-label" for="senderEmail">Email</label>
            <div class="form-group ">
              <input type="text" id="senderEmail" [(ngModel)]="senderEmail" class="form-control"
                     (blur)="typeSenderEmail()"
                     [ngClass]="{'is-invalid':statusText2}" [ngModelOptions]="{standalone: true}" required>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText2" [hidden]="!statusText2">
                {{statusText2}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 required">
            <label class="control-label" for="senderPhone">Phone Number</label>
            <div class="form-group ">
              <input type="text" id="senderPhone" [(ngModel)]="senderMobile" class="form-control"
                     (blur)="typeSenderMobile()"
                     [ngClass]="{'is-invalid':statusText3}"
                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"
                     [ngModelOptions]="{standalone: true}" required>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText3" [hidden]="!statusText3">
                {{statusText3}}
              </div>
            </div>
          </div>
          <div class="col-md-4 required">
            <label class="control-label" for="senderStreetAddress">Address</label>
            <div class="form-group ">
              <input type="text" id="senderStreetAddress" [(ngModel)]="address.address1"
                     class="form-control"
                     (blur)="typeSenderAddress1()" [ngClass]="{'is-invalid':statusText4}"
                     [ngModelOptions]="{standalone: true}"
                     required>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText4" [hidden]="!statusText4">
                {{statusText4}}
              </div>
            </div>
          </div>
          <div class="col-md-4 required">
            <label class="control-label">City</label>
            <div class="form-group ">
              <ng-select type="text" id="senderCity" [(ngModel)]="address.city" [addTag]="true"
                         (blur)="typeSenderCity()" placeholder="city" [items]="citiesList"
                         [ngClass]="{'is-invalid':statusText5}" [ngModelOptions]="{standalone: true}" required>
              </ng-select>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText5" [hidden]="!statusText5">
                {{statusText5}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 required">
            <label class="control-label">State</label>
            <div class="form-group ">
              <ng-select id="senderState" [(ngModel)]="address.state"
                         [ngModelOptions]="{standalone: true}"
                         [ngClass]="{'service-error':statusText6}"
                         (blur)="typeSenderState()"
                         [ngClass]="{'is-invalid':statusText6}"
                         [items]="statesList"
                         placeholder="State">
              </ng-select>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText6" [hidden]="!statusText6">
                {{statusText6}}
              </div>
            </div>
          </div>
          <div class="col-md-4 required">
            <label class="control-label" for="senderZip">Zip</label>
            <div class="form-group ">
              <input type="text" id="senderZip" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                     maxlength="6" (change)="changeCityAndState()"
                     [(ngModel)]="address.zip" class="form-control" (blur)="typeSenderZip()"
                     [ngClass]="{'is-invalid':statusText7}" [ngModelOptions]="{standalone: true}" required>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText7" [hidden]="!statusText7">
                {{statusText7}}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0">
          <button type="reset" class="btn btn-cancel" (click)="cancelPopup()">Close</button>
          <button type="submit" (click)="submitSender()" class="btn btn-orange ml-2">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div [ngStyle]="{'display': newReceiverPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': newReceiverPopup == 'Y'}" class="modal" id="receiverDetails" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document" style="max-width:900px">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h2 class="modal-title">Receiver Details
          <span class="dot bg-danger"
                *ngIf="statusText8 || statusText9 || statusText10 || statusText11 || statusText12 || statusText13 || statusText14">
              </span>
        </h2>
        <button type="button" class="close" (click)="cancelPopup()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4">
            <label class="control-label" for="receiverCompanyName">Company Name</label>
            <div class="form-group ">
              <input type="text" id="receiverCompanyName" [(ngModel)]="receiverCompanyName" class="form-control"
                     [ngClass]="{'is-invalid':statusText8}" [ngModelOptions]="{standalone: true}"
                     onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                     autocomplete="off" required>
            </div>
          </div>
          <div class="col-md-4 required">
            <label class="control-label" for="receiverName">Contact Name</label>
            <div class="form-group ">
              <input type="text" id="receiverName" [(ngModel)]="receiverContactName" class="form-control"
                     (blur)="typeReceiverName()"
                     [ngClass]="{'is-invalid':statusText8}" [ngModelOptions]="{standalone: true}"
                     onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                     autocomplete="off" required>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText8" [hidden]="!statusText8">
                {{statusText8}}
              </div>
            </div>
          </div>
          <div class="col-md-4 ">
            <label class="control-label" for="receiverEmail">Email</label>
            <div class="form-group ">
              <input type="text" id="receiverEmail" [(ngModel)]="receiverEmail" class="form-control"
                     (blur)="typeReceiverEmail()"
                     [ngClass]="{'is-invalid':statusText9}" [ngModelOptions]="{standalone: true}" required>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 required">
            <label class="control-label" for="receiverPhone">Phone Number</label>
            <div class="form-group ">
              <input type="text" id="receiverPhone" [(ngModel)]="receiverMobile" class="form-control"
                     (blur)="typeReceiverMobile()"
                     [ngClass]="{'is-invalid':statusText10}"
                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"
                     [ngModelOptions]="{standalone: true}" required>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText10"
                   [hidden]="!statusText10">
                {{statusText10}}
              </div>
            </div>
          </div>
          <div class="col-md-4 required">
            <label class="control-label" for="receiverStreetAddress">Address</label>
            <div class="form-group ">
              <input type="text" id="receiverStreetAddress" [(ngModel)]="address.address1"
                     class="form-control"
                     (blur)="typeReceiverAddress1()" [ngClass]="{'is-invalid':statusText11}"
                     [ngModelOptions]="{standalone: true}"
                     required>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText11"
                   [hidden]="!statusText11">
                {{statusText11}}
              </div>
            </div>
          </div>
          <div class="col-md-4 required">
            <label class="control-label">City</label>
            <div class="form-group ">
              <ng-select type="text" id="receiverCity" [(ngModel)]="address.city" [addTag]="true"
                         (blur)="typeReceiverCity()" placeholder="City" [items]="citiesList" [addTag]="true"
                         [ngClass]="{'is-invalid':statusText12}" [ngModelOptions]="{standalone: true}" required>
              </ng-select>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText12"
                   [hidden]="!statusText12">
                {{statusText12}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 required">
            <label class="control-label">State</label>
            <div class="form-group ">
              <ng-select id="receiverState" [(ngModel)]="address.state"
                         [ngModelOptions]="{standalone: true}"
                         [ngClass]="{'service-error':statusText13}"
                         (blur)="typeReceiverState()"
                         [ngClass]="{'is-invalid':statusText13}"
                         [items]="statesList"
                         placeholder="State">
              </ng-select>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText13"
                   [hidden]="!statusText13">
                {{statusText13}}
              </div>
            </div>
          </div>
          <div class="col-md-4 required">
            <label class="control-label" for="receiverZip">Zip</label>
            <div class="form-group ">
              <input type="text" id="receiverZip" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                     maxlength="6" placeholder="Enter PinCode" (change)="changeCityAndState()"
                     [(ngModel)]="address.zip" class="form-control" (blur)="typeReceiverZip()"
                     [ngClass]="{'is-invalid':statusText14}" [ngModelOptions]="{standalone: true}" required>
              <div class="invalid-feedback d-block shift-invalid-login" id="statusText14"
                   [hidden]="!statusText14">
                {{statusText14}}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0">
          <button type="reset" class="btn btn-cancel" (click)="cancelPopup()">Close</button>
          <button type="submit" (click)="submitReceiver()" class="btn btn-orange ml-2">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': newProductPopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': newProductPopup == 'Y'}" class="modal" id="productDetails" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document" style="max-width:900px">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h2 class="modal-title">Product Details
          <span class="dot bg-danger"
                *ngIf="statusText15 || statusText16 || statusText17 || statusText19 ">
              </span>
        </h2>
        <button type="button" class="close" (click)="cancelPopup()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText19">{{statusText19}}</div>
          <div class="col-md-12 mt-2 mb-2 required">
            <div class="row">
              <div class="col-md-4">
                <div class="required">
                  <label class="control-label" for="productName">Product Name</label>
                  <div class="form-group">
                    <input type="text" id="productName" [(ngModel)]="productName" class="form-control"
                           (blur)="typeProduct()" [ngClass]="{'is-invalid':statusText15}"
                           [ngModelOptions]="{standalone: true}" required>
                    <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText15">
                      {{statusText15}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 required">
                <label class="control-label" for="sku">Store SKU</label>
                <div class="form-group ">
                  <input type="text" id="storeSku" [(ngModel)]="storeSku" class="form-control" (blur)="typeStoreSKU()"
                         (change)="skuValue()" [ngClass]="{'is-invalid':statusText16}" maxlength="12"
                         [ngModelOptions]="{standalone: true}" required>
                  <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText16">
                    {{statusText16}}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label for="sku">SKU</label>
                <div class="form-group ">
                  <input type="text" id="sku" [(ngModel)]="sku" class="form-control"
                         [ngModelOptions]="{standalone: true}" disabled>
                </div>
              </div>
              <div class="col-md-4">
                <label>Dimensions (cms)</label>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <input type="text" id="length" [(ngModel)]="productLength" class="form-control" placeholder="l(cms)"
                             [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input type="text" id="width" [(ngModel)]="productWidth" class="form-control" placeholder="w(cms)"
                             [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <input type="text" id="height" [(ngModel)]="productHeight" class="form-control" placeholder="h(cms)"
                             [ngModelOptions]="{standalone: true}" required>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label for="weights">Weight</label>
                <div class="form-group">
                  <input type="text" id="weights" [(ngModel)]="weight" class="form-control"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-md-4 required">
                <label class="control-label" for="hsncode">HSN Code</label>
                <div class="form-group ">
                  <input type="text" id="hsnCode" [(ngModel)]="hsnCode" maxlength="50" class="form-control"
                         (blur)="typeHsnCode()" [ngClass]="{'is-invalid':statusText17}"
                         [ngModelOptions]="{standalone: true}" required>
                  <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText17">
                    {{statusText17}}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <label for="price">Price</label>
                <div class="form-group ">
                  <input type="text" id="price" [(ngModel)]="price" class="form-control"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-md-4">
                <label for="tax">Tax Rate (%)</label>
                <div class="form-group ">
                  <input type="text" id="tax" [(ngModel)]="taxRate" class="form-control"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0">
        <button type="reset" class="btn btn-cancel" (click)="cancelPopup()">Close</button>
        <button type="submit" (click)="submitCreateProduct()" class="btn btn-orange ml-2">Save</button>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': creditBalancePopup =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': creditBalancePopup == 'Y'}" class="modal" id="creditBal" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document" style="max-width:900px">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h2 class="modal-title">Add Credits
        </h2>
        <button type="button" class="close" (click)="cancelPopup()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 mt-2 mb-2 required">
            <div class="row d-flex justify-content-around my-3">
              <div class="col-md-6">
                <div class="row d-flex justify-content-around">
                  <div class="col form-group">
                    <label class="control-label">Amount</label>
                    <input type="text" id="amount" class="form-control" (blur)="typeAmount()"
                           [ngClass]="{'is-invalid':amountError}" [(ngModel)]="amount"
                           [ngModelOptions]="{standalone: true}" appOnlyNumbers required>
                    <div id="amountError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!amountError">
                      {{amountError}}
                    </div>
                  </div>
                  <div class="col-md-6 ms-1">
                    <button id="Button" class="btn btn-orange" (click)="submitCreditBal()" style="margin-top: 23px;">Pay Now</button>
                  </div>
                </div>
              </div>
              <div class=" col-md-6 " style="text-align: right">
                <img referrerpolicy="origin"
                     src="https://badges.razorpay.com/badge-dark.png "
                     style="height: 67px;width: 165px;"
                     alt="Razorpay | Payment Gateway | Neobank">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

